import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { connect, useSelector, useDispatch } from "react-redux";
import { getDailyPnl } from "../../actions/dashboard-action";
import { HIDE_GRAPH } from "../../actions/types";
import { roundNumber } from "../../utils/Utils";
import { ChartColors } from "../../Const";
import "./DailyPnlPanel.scss";

const DailyPnlPanel = (props) => {
  const { getDailyPnl, hideGraph, showHideBtn ,t} = props;

  const dailyPnl = useSelector((state) => state.dashboard.dailyPnl) || {};
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  const currency = useSelector((state) => state.settings.currency);
  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const chartData = dailyPnl.chart_data || [];

  const allPnL = (dailyPnl.pnl && dailyPnl.pnl.fiat) || "0";

  const funds = chartData.map((item) =>
    roundNumber(Number((item.y || "0").replace(",", "")))
  );
  const colors = funds.map((item) => (item >= 0 ? ChartColors[theme][1] : ChartColors[theme][2]));
  const labels = chartData.map((item) => item.x);
  const minValue = Math.min(...funds);

  const dispatch = useDispatch();
  const clickHideGraph = () =>
    dispatch({
      type: HIDE_GRAPH,
      payload: true,
    });

  useEffect(() => {
    getDailyPnl(selectedExchangeId);
  }, [selectedExchangeId]);

  return (
    <div className="pnl-panel">
      <hr />
      <Row className="text-title">
        <Col></Col>
        <Col xs={4}>APY</Col>
        <Col xs={4}>{t("atp")}</Col>
      </Row>
      <Row className={Object.keys(dailyPnl).length==0?'hide-pnl':'text-value'}>
        <Col></Col>
        <Col xs={4}>{dailyPnl.apy}%</Col>
        <Col xs={4}>
          {allPnL} {currency && currency.name}
        </Col>
      </Row>
      <hr />
      {!hideGraph && (
        <div className="graph-container round-bg">
          <div
            style={{ marginBottom: 35 }}
            className="d-flex justify-content-between"
          >
            <h6>{t("d-pnl")}</h6>
            {showHideBtn && (
              <button className="hide-btn" onClick={clickHideGraph}>
                Hide &#94;
              </button>
            )}
          </div>
          <Bar
            data={dataBar(funds, labels, colors)}
            options={options(minValue)}
          />
        </div>
      )}
    </div>
  );
};

export default connect(null, { getDailyPnl })(DailyPnlPanel);

const dataBar = (funds, labels, colors) => ({
  labels,
  datasets: [
    {
      backgroundColor: colors,
      borderWidth: 1,
      minBarLength: 2,
      data: funds,
      barThickness: 20,
      borderRadius: 8,
    },
  ],
});

const options = (minValue) => {
  const fontSize = 11;
  const fontColor = "#4c556a";
  return {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            fontSize,
            fontColor,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            min: minValue,
            fontSize,
            fontColor,
          },
        },
      ],
    },
  };
};
